import { FlagQuery, useFlag as useOpenFeatureFlag } from '@openfeature/react-sdk';
import { FlagValue } from '@openfeature/web-sdk';

import { DatadogFlag, DatadogFlagType, datadogFlagFallbacks } from './flags';

/**
 * Reads a Datadog flag. Same call shape as the LaunchDarkly `useFlag`, so a
 * call site reads the same whichever provider is behind it, and the fallback
 * comes from the flag's own declaration rather than the caller.
 */
export function useDatadogFlag<F extends DatadogFlag>(flag: F): DatadogFlagType<F> {
  return useDatadogFlagQuery(flag).value as DatadogFlagType<F>;
}

/**
 * The full evaluation, not just the value: which variant matched, why, and
 * whether it defaulted because of an error.
 *
 * A flag reading its fallback and a flag no targeting rule selected are the
 * same value and different facts, and only `reason` tells them apart — which
 * is what makes a rollout verifiable rather than merely plausible.
 */
export function useDatadogFlagQuery<F extends DatadogFlag>(flag: F): FlagQuery<FlagValue> {
  return useOpenFeatureFlag<FlagValue>(flag, datadogFlagFallbacks[flag] as FlagValue);
}
